import React from 'react';
import { connect } from 'react-redux';
import MiniCart from '../Components/MiniCart';
import { toggle } from '../Actions/Cart.action';
import { update as updateOrderRow } from '../Actions/Cart.action';

const MiniCartContainer = props => <MiniCart {...props} />;

const mapStateToProps = state => {
    const { cart } = state;
    return {
        ...cart,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
        updateOrderRowQuantity: (rowId, quantity) =>
            dispatch(updateOrderRow(rowId, { quantity })),
        removeOrderRow: rowId =>
            dispatch(updateOrderRow(rowId, { quantity: 0 })),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartContainer);
